<template>
  <div id="app">
    <section
      id="background"
      class="row map"
      :class="{'row docks': gameAreaDocks, 'row forest': gameAreaForest, 'row graveyard': gameAreaGraveYard }"
    >
      <div v-if="welcomeScreen">
        <p>welcome to</p>
        <h1>Hellspawn Hunter</h1>
      </div>
      <div class="small-6 columns" v-if="gameIsRunning">
        <h1 class="text-center">Hero</h1>

        <img
          src="./images/ourHero.png"
          alt="ourHero"
          v-if="(playerHealth > 0) && !playerAttack && !playerAttackGun && !playerWon"
        />
        <!-- There can be only one! -->

        <img
          src="./images/ourHeroWon.png"
          alt="ourHeroWon"
          v-else-if="(playerHealth > 0) && playerWon && !playerAttack"
        />

        <img
          src="./images/ourHeroAttack_ezgif-4b.gif"
          class="heroattack"
          alt="ourHeroAttack"
          v-else-if="(playerHealth > 0) && playerAttack && !playerWon"
        />

        <img
          src="./images/ourHeroAttackGun_single.png"
          class="heroattackgun"
          alt="ourHeroAttack"
          v-else-if="(playerHealth > 0) && !playerAttack && playerAttackGun && !playerWon"
        />

        <img src="./images/ourHeroDead.png" alt="ourHeroDead" v-else-if="playerHealth <= 0" />
        <div class="muzzle" v-if="playerAttackGun"></div>
        <div class="healAura" v-if="playerHealing"></div>
        <div class="currentDamage" v-if="currentDamage">{{ currentDamage }}</div>
        <div class="currentMonsterDamage" v-if="currentMonsterDamage">{{ currentMonsterDamage }}</div>
        <div class="healthbar">
          <div
            class="healthbar text-center bloodbar"
            v-if="playerHealth <= 100"
            :style="{ width: playerHealth + '%'}"
          >{{ playerHealth }}</div>
          <div
            class="healthbar text-center bloodbar uberHealth"
            v-else
            :style="{ width: 100 + '%'}"
          >{{ playerHealth }}</div>
          <p class="info">Special Attacks left: {{ playerSpecials }} x 💣</p>
          <p class="info">Heal Packs left: {{ playerHeals }} x 🍫</p>
        </div>
      </div>

      <div class="small-6 columns" v-if="gameIsRunning && skel">
        <h1 class="text-center">{{ currentMonster.name }}</h1>
        <img src="./images/skel.png" alt="theMonster" v-if="monsterHealth > 0 && !monsterAttack" />
        <img
          src="./images/skelAttack.png"
          class="monsterattack"
          alt="theMonsterAttack"
          v-else-if="monsterHealth > 0 && monsterAttack"
        />
        <img src="./images/skelDead.png" alt="theMonsterDead" v-else />

        <div class="healthbar">
          <div
            class="healthbar text-center bloodbar"
            v-if="monsterHealth <= 100"
            :style="{ width: monsterHealth + '%'}"
          >{{ monsterHealth }}</div>
          <div
            class="healthbar text-center bloodbar uberHealth"
            v-else
            :style="{ width: 100 + '%'}"
          >{{ monsterHealth }}</div>
          <p class="info">
            Worth:
            <span class="exp">{{ currentMonster.worth }}</span>
          </p>
        </div>
      </div>

      <div class="small-6 columns" v-if="gameIsRunning && spider">
        <h1 class="text-center">{{ currentMonster.name }}</h1>
        <img
          src="./images/theMonster.png"
          alt="theMonster"
          v-if="monsterHealth > 0 && !monsterAttack"
        />
        <img
          src="./images/theMonsterAttack.png"
          class="monsterattack"
          alt="theMonsterAttack"
          v-else-if="monsterHealth > 0 && monsterAttack"
        />
        <img src="./images/theMonsterDead.png" alt="theMonsterDead" v-else />

        <div class="healthbar">
          <div
            class="healthbar text-center bloodbar"
            v-if="monsterHealth <= 100"
            :style="{ width: monsterHealth + '%'}"
          >{{ monsterHealth }}</div>
          <div
            class="healthbar text-center bloodbar uberHealth"
            v-else
            :style="{ width: 100 + '%'}"
          >{{ monsterHealth }}</div>
          <p class="info">
            Worth:
            <span class="exp">{{ currentMonster.worth }}</span>
          </p>
        </div>
      </div>

      <div class="small-6 columns" v-if="gameIsRunning && theRed">
        <h1 class="text-center">{{ currentMonster.name }}</h1>
        <img
          src="./images/darkmonk-mod2-200percent.png"
          class="monkFix floatingMonk"
          alt="theMonster"
          v-if="monsterHealth > 0 && !monsterAttack"
        />
        <img
          src="./images/darkmonk-mod2casting.png"
          class="monsterattack monkFixAttack"
          alt="theMonsterAttack"
          v-else-if="monsterHealth > 0 && monsterAttack"
        />
        <img src="./images/darkmonk-mod2dead.png" class="monk" alt="theMonsterDead" v-else />

        <div class="healthbar">
          <div
            class="healthbar text-center bloodbar"
            v-if="monsterHealth <= 100"
            :style="{ width: monsterHealth + '%'}"
          >{{ monsterHealth }}</div>
          <div
            class="healthbar text-center bloodbar uberHealth"
            v-else
            :style="{ width: 100 + '%'}"
          >{{ monsterHealth }}</div>
          <p class="info">
            Worth:
            <span class="exp">{{ currentMonster.worth }}</span>
          </p>
        </div>
      </div>
    </section>

    <section class="row controls" v-if="!gameIsRunning">
      <span>
        We are looking at the map. Wondering where to go.
        Hero Health is:
        <span
          class="uberHealth"
        >{{ playerHealth }} ⚕</span> and EXP is:
        <span class="exp">{{ exp }} ★</span>
      </span>

      <div class="small-12 columns" @mouseover="walking = true" @mouseleave="walking = false">
        <button class="start-game start-btn-graveyard" v-on:click="startGame(2)">
          GO TO
          <br />THE GRAVEYARD
          <br />(easy monster)
        </button>
        <button class="start-game start-btn-docks" v-on:click="startGame(0)">
          GO TO
          <br />THE DOCKS
          <br />(medium monster)
        </button>
        <button class="start-game start-btn-forest" v-on:click="startGame(1)">
          GO TO
          <br />THE FOREST
          <br />(hard monster)
        </button>

        <div id="titleImg" v-if="!walking">
          <img src="./images/hero1_card.png" />
        </div>
        <div id="titleImg" v-else>
          <img src="./images/hero1_card-walk.png" />
        </div>
      </div>

      <div>
        <p>You can level up for 50 EXP</p>
        <button id="lvlUp" v-on:click="useExp" v-if="exp >= 50">level up ▲</button>
        <button disabled id="lvlUp" v-on:click="useExp" v-else>level up ▲</button>
      </div>
    </section>

    <section class="row controls" v-else>
      <div class="small-12 columns">
        <div class="tooltip">
          <button id="attack" @click="attack" v-if="!playerAttack">ATTACK ⚔</button>
          <button disabled v-else>ATTACK ⚔</button>
          <span class="tooltiptext">Melee Damage: 3 - 12</span>
        </div>
        <div class="tooltip">
          <button
            id="special-attack"
            @click="specialAttack"
            v-if="!playerAttack && playerSpecials > 0"
          >SPECIAL ATTACK 💣</button>
          <button disabled v-else>SPECIAL ATTACK 💣</button>
          <span class="tooltiptext">Rifle Damage: 13 - 33</span>
        </div>
        <div class="tooltip">
          <button id="heal" @click="heal" v-if="!playerHealing && playerHeals > 0">HEAL 🍫</button>
          <button disabled v-else>HEAL 🍫</button>
          <span class="tooltiptext">Heal: 9</span>
        </div>
        <div class="tooltip">
          <button id="back-to-map" class="map" @click="backToMap">Back To Map ☁</button>
          <span class="tooltiptext">Leave this Place</span>
        </div>
      </div>
    </section>
    <section class="row log" v-if="turns.length">
      <div class="small-12 columns">
        <ul>
          <li
            v-bind:key="turn.text"
            v-for="turn in turns"
            :class="{'player-turn': turn.isPlayer, 'monster-turn': !turn.isPlayer}"
          >{{ turn.text }}</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      welcomeScreen: true,
      walking: false,
      gameIsRunning: false,
      exp: 0,
      gainedExp: 0,
      playerBaseHealth: 100,
      playerHealth: 100, //Initial
      monsterHealth: 0,
      monsterAttack: false,
      playerAttack: false,
      playerAttackGun: false,
      playerHealing: false,
      playerWon: false,
      playerSpecials: 1,
      playerHeals: 3,
      turns: [],

      //Areas:
      gameAreaDocks: false,
      gameAreaForest: false,
      gameAreaGraveYard: false,
      //Monster Types and their worth:
      skel: false,
      spider: false,
      theRed: false,
      skelWorth: 15,
      spiderWorth: 75,
      theRedWorth: 200,
      //What is the active Monster Type?
      currentMonster: { name: "", worth: 0 },
      currentDamage: 0,
      currentMonsterDamage: 0
    };
  },
  updated() {
    if (this.gameAreaDocks) {
      this.currentMonster.name = "Spider";
      this.currentMonster.worth = this.spiderWorth;
    }
    if (this.gameAreaForest) {
      this.currentMonster.name = "Dark Monk";
      this.currentMonster.worth = this.theRedWorth;
    }
    if (this.gameAreaGraveYard) {
      this.currentMonster.name = "Skeleton";
      this.currentMonster.worth = this.skelWorth;
    }
  },
  beforeMount() {
    //this.getExp(); //Exp from Server
  },
  methods: {
    // Server Connections:
    getExp() {
      const processExp = expS => {
        this.exp = +expS; //like parseInt

        console.info("Getting EXP from Server: ", expS);
      };

      const fetchExp = () => {
        fetch("/serverexp")
          .then(res => res.text())
          .then(processExp)
          .catch(console.log);
      };

      fetchExp();
    },
    submitExp() {
      const postExp = () => {
        fetch("/clientexp", {
          method: "POST",
          headers: { "Content-type": "application/json; charset=UTF-8" },
          body: JSON.stringify({
            exp: +this.exp
          })
        })
          .then(res => res.json())
          .then(this.getExp())
          .catch(() => {});
      };
      postExp();
    },
    getMonster() {
      const processMonster = monsterHealthS => {
        this.monsterHealth = +monsterHealthS; //like parseInt
      };

      const fetchMonster = () => {
        fetch("/servermonster")
          .then(res => res.text())
          .then(processMonster)
          .catch(console.log);
      };

      fetchMonster();
    },

    // Game Functions:

    startGame(mode) {
      this.welcomeScreen = false;
      this.gameIsRunning = true;
      //this.playerHealth = 100; //Now you have to live with what you've done
      //this.monsterHealth = 100; //Now getting from selected mode
      this.playerSpecials = 1; //Always have a new Bullet for every fight.
      this.playerAttackGun;
      this.playerHeals;
      this.playerWon = false;
      this.gainedExp = 0;

      //this.turns = []; //Log Reset or not?
      //select mode:
      //DOCKS:
      if (mode == 0) {
        this.gameAreaDocks = true;
        this.gameAreaForest = false;
        this.gameAreaGraveYard = false;
        this.spider = true;
        this.skel = false;
        this.theRed = false;
        this.monsterHealth = 80;
      }
      //FOREST:
      if (mode == 1) {
        this.gameAreaDocks = false;
        this.gameAreaForest = true;
        this.gameAreaGraveYard = false;
        this.theRed = true;
        this.spider = false;
        this.skel = false;
        this.monsterHealth = 666;
        //this.getMonster(); // MonsterHealthS getting from Server!
      }
      //GRAVEYARD:
      if (mode == 2) {
        this.gameAreaDocks = false;
        this.gameAreaForest = false;
        this.gameAreaGraveYard = true;
        this.skel = true;
        this.theRed = false;
        this.spider = false;
        this.monsterHealth = 50;
      }
    },

    // FOUR ACTION BUTTONS:

    attack() {
      // Hero Attacks:
      if (this.monsterHealth > 0 && this.playerHealth > 0) {
        let damage = this.calcDmg(3, 12);
        this.currentDamage = damage;
        this.monsterHealth -= damage;
        this.playerAttack = true;
        this.turns.unshift({
          isPlayer: true,
          text: "Hero hits " + this.currentMonster.name + " for " + damage
        });

        if (this.checkWin()) {
          return;
        }

        setTimeout(() => {
          this.playerAttack = false;
          this.currentDamage = 0;
          // Monster Attacks Back:
          this.monsterAttacks();
        }, 800);
      }
    },

    specialAttack() {
      // Hero Special Attack:
      if (
        this.playerSpecials > 0 &&
        this.monsterHealth > 0 &&
        this.playerHealth > 0
      ) {
        this.playerAttackGun = true;
        let damage = this.calcDmg(13, 33);
        //Using the Gun needs some time:
        setTimeout(() => {
          this.currentDamage = damage;
          this.monsterHealth -= damage;
          this.turns.unshift({
            isPlayer: true,
            text:
              "Hero uses Special and hits " +
              this.currentMonster.name +
              " for " +
              damage
          });

          this.checkWin();
        }, 1200);

        //To Do Maybe: Special Attack can cause Monster-Mutation?

        //this.playerSpecialAttack = true;
        this.playerSpecials--;
      } else {
        alert(
          "Out of Specials! (Or Monster is already dead) - No Damage was dealt to the Monster!"
        );
        return;
      }

      if (this.checkWin()) {
        return;
      }

      // Monster Attacks:
      if (this.monsterHealth > 0) {
        setTimeout(() => {
          this.playerAttackGun = false;
          this.currentDamage = 0;
          // Monster Attacks:
          if (this.monsterHealth > 0) this.monsterAttacks();
        }, 1800);
        return;
      }
    },

    heal() {
      // Hero Healing:
      if (
        this.playerHeals > 0 &&
        this.playerHealth < 100 &&
        this.playerHealth > 0
      ) {
        this.playerHealth += 9;
        this.playerHealing = true;
        this.turns.unshift({
          isPlayer: true,
          text: "Hero heals for 9"
        });
        //this.playerHeals = true;
        this.playerHeals--;
      } else if (this.playerHeals > 0) {
        alert("No can do! Health is at max! (Or Hero is no more)");
      } else {
        alert("Out of Heal Packs! No healing recieved!");
      }

      setTimeout(() => {
        this.playerHealing = false;
        // Monster Attacks:

        if (this.monsterHealth > 0) {
          this.monsterAttacks();
          return;
        }
      }, 1000);
    },

    backToMap() {
      if (this.playerHealth > 0) {
        /*if (confirm('Are you sure you want to go back?')){
                } else {
                    return;
                }*/
        this.currentDamage = 0;
        this.currentMonsterDamage = 0;
        this.gameIsRunning = false;
        this.turns.unshift({
          text: "Hero runs back to where he came from!"
        });

        //Unload Area BGs:
        this.gameAreaDocks = false;
        this.gameAreaForest = false;
        this.gameAreaGraveYard = false;
      }
    },

    // EXP Management:

    gainExp() {
      if (this.theRed) {
        this.gainedExp += 200;
      } else if (this.spider) {
        this.gainedExp += 75;
      } else if (this.skel) {
        this.gainedExp += 15;
      }
      this.turns.unshift({
        isPlayer: true,
        text: "Hero gains " + this.gainedExp + " EXP from the fight!"
      });
    },
    useExp() {
      if (this.exp >= 50) {
        this.exp = this.exp - 50;
        this.playerBaseHealth = this.playerBaseHealth + 10;
        this.playerHealth = this.playerBaseHealth;

        this.turns.unshift({
          text: "You have leveled up! New Health is now " + this.playerHealth
        });

        //Updating EXP on Server:
        //this.submitExp();
      }
    },

    monsterAttacks() {
      let damage;
      if (this.theRed) {
        damage = this.calcDmg(16, 32);
      } else {
        damage = this.calcDmg(4, 12);
      }
      this.currentMonsterDamage = damage;
      this.playerHealth -= damage;
      this.checkWin();
      this.turns.unshift({
        isPlayer: false,
        text: this.currentMonster.name + " hits Hero for " + damage
      });

      this.monsterAttack = true;
      setTimeout(() => {
        this.monsterAttack = false;
        this.currentMonsterDamage = 0;
        return;
      }, 1000);
    },

    // Damage Calculation - Used by both - Hero and Monster:

    calcDmg(min, max) {
      return Math.max(Math.floor(Math.random() * max) + 1, min);
    },

    checkWin() {
      if (this.monsterHealth <= 0) {
        this.turns.unshift({
          isPlayer: true,
          text: "Hero sends the Hellspawn back to hell!"
        });

        //Gain of EXP for Winning:
        this.gainExp();
        this.exp += this.gainedExp;

        //Updating EXP on Server:
        //this.submitExp();

        //Monster is dead and drops random amount of items:
        let newHealPacks = Math.max(Math.floor(Math.random() * 4) + 1, 2);
        this.playerHeals = this.playerHeals + newHealPacks;
        this.turns.unshift({
          isPlayer: true,
          text: `Hero found ${newHealPacks} Heal Packs and has now: ${this.playerHeals} Packs!`
        });

        /*
                if (confirm('Hero Won! New Game?')){
                    this.startGame();
                } else {
                    //this.gameIsRunning = false;
                    this.playerAttack = false;
                    this.playerWon = true;
                }
                */
        this.playerAttackGun = false;
        this.playerAttack = false;
        this.playerWon = true;

        return true;
      } else if (this.playerHealth <= 0) {
        this.turns.unshift({
          isPlayer: false,
          text: "The Hellspawns have destroyed the Hero!"
        });
        if (confirm("Hero is lost! New Game?")) {
          //this.startGame();
          location.reload();
        } else {
          //this.gameIsRunning = false;
          this.playerAttack = false;
          this.playerWon = false;
        }
        return true;
      }
      return false;
    }
  },
  components: {}
};
</script>

<style>
/* @import url('https://fonts.cdnfonts.com/css/thegoodmonolith'); */
@import "./assets/styles/app.css";
@import "./assets/styles/foundation.min.css";
@import "./assets/styles/tooltip.css";

@font-face {
  font-family: "TheGoodMonolith";
  font-style: normal;
  font-weight: 500;
  src: local("TheGoodMonolith"),
    url("./fonts/TheGoodMonolith.woff") format("woff");
}

* {
  font-family: "TheGoodMonolith", "Major Mono Display", "dos", DOS, Monaco,
    Menlo, Consolas, "Courier New", monospace;
  font-weight: 800;
}

body {
  background-color: #000;
  color: #999;
}
img {
  text-align: center;
  margin-left: 12em;
  margin-bottom: 24px;
  transform: scale(2);
  image-rendering: crisp-edges;
}
p {
  margin: auto;
}
h1 {
  font-size: 4em;
  margin-top: 0em;
  opacity: 0.7;
}

#titleImg {
  position: relative;
  width: 1rem;
  left: 4rem;
  top: -20rem;
}

.monkFix {
  margin-top: -84px;
}
.monkFixAttack {
  margin-top: -24px;
}

.monsterattack {
  filter: drop-shadow(16px 0px 16px #c66);
  margin-left: 6em;
  transition: margin-left 666ms ease-out;
}
.heroattack {
  filter: drop-shadow(-8px 0px 16px #c66);
  margin-left: 18em;
  transition: margin-left 666ms ease-out;
}

.muzzle {
  position: absolute;
  width: 40px;
  height: 8px;
  background-color: #ffa500;
  top: 132px;
  left: 13em;
  z-index: 9;
  opacity: 0;
  filter: blur(1px);
  animation-name: boom;
  animation-duration: 800ms;
}

.healAura {
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: #119977;
  top: 120px;
  left: 11em;
  z-index: 9;
  opacity: 0;
  filter: blur(1px);
  animation-name: aura;
  animation-duration: 2s;
  border-radius: 50%;
}

.currentDamage {
  position: absolute;
  width: 80px;
  height: 80px;
  color: #996911;
  top: 128px;
  left: 21em;
  font-size: 2em;
  z-index: 9;
  opacity: 0.1;
  filter: blur(0.1);
  animation-name: showDmg;
  animation-duration: 4s;
}

.currentMonsterDamage {
  position: absolute;
  width: 80px;
  height: 80px;
  color: #996911;
  top: 128px;
  left: 6em;
  font-size: 2em;
  z-index: 9;
  opacity: 0.1;
  filter: blur(0.1);
  animation-name: showDmg;
  animation-duration: 4s;
}

.info {
  font-size: smaller;
  font-weight: 700;
  margin-top: 2px;
}

.row.dust {
  background-image: linear-gradient(
    to top,
    rgba(200, 100, 140, 0.2),
    rgba(11, 11, 111, 0)
  );
  height: 272px;
}
.row.map {
  background-image: linear-gradient(
      to top,
      rgba(100, 160, 120, 0.2),
      rgba(11, 11, 111, 0)
    ),
    url("../images/bg-hsh-map3.png");
  height: 272px;
}
.row.forest {
  background-image: linear-gradient(
      to top,
      rgba(200, 100, 140, 0.2),
      rgba(11, 11, 111, 0)
    ),
    url("../images/bg-hsh1.png");
  height: 272px;
}
.row.docks {
  background-image: linear-gradient(
      to top,
      rgba(100, 120, 140, 0.2),
      rgba(11, 11, 111, 0)
    ),
    url("../images/bg-hsh2.png");
  height: 272px;
}
.row.graveyard {
  background-image: linear-gradient(
      to top,
      rgba(100, 90, 140, 0.4),
      rgba(11, 11, 111, 0)
    ),
    url("../images/bg-hsh3.png");
  height: 272px;
}

.small-6 {
  width: 50%;
  top: 0.5em;
  position: relative;
}

.text-center {
  text-align: center;
}

.healthbar {
  width: 80%;
  height: 20px;
  /* background-color: #333; */
  /* background-image: linear-gradient(to right, darkred , darkgreen); */
  background-image: linear-gradient(to bottom, rgb(64, 64, 64), rgb(0, 0, 0));
  margin: auto;
  margin-bottom: 10px;
  transition: width 500ms;
  border-radius: 3px;
}

.bloodbar {
  background-image: linear-gradient(to bottom, rgb(160, 4, 4), rgb(32, 2, 2));
  margin: 0;
  color: #ccc;
}

.uberHealth {
  color: #ffa500;
}

.exp {
  color: #2594d7;
}

.controls,
.log {
  margin-top: 16px;
  text-align: center;
  padding: 2px;
  border: 1px solid #ccc;
  box-shadow: 0px 3px 6px #ccc;
}

.turn {
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 14px;
}

.log ul {
  color: #dca;
  list-style: none;
  font-weight: bold;
  text-transform: uppercase;
}

.log ul li {
  margin: 2px;
  font-size: 14px;
}

.log ul .player-turn {
  background-color: #222;
}

.log ul .monster-turn {
  background-color: #111;
}

button {
  font-size: 20px;
  /* background-color: #eee; */
  padding: 8px;
  box-shadow: 0 4px 1px #333;
  margin: 4px;
  color: #777;
  border: 2px #555 solid;
}

button:hover {
  border: 2px #888 solid;
}

button[disabled="disabled"],
button:disabled {
  opacity: 0.4;
  box-shadow: 0;
}

.start-game {
  background: linear-gradient(
      to top,
      rgba(200, 100, 140, 0.2),
      rgba(11, 11, 111, 0)
    ),
    url("../images/bg-hsh-map2.png");
  color: #bbb;
  width: 200px;
  height: 160px;
}

.start-game:hover {
  background: linear-gradient(
      to top,
      rgba(44, 10, 14, 0.4),
      rgba(11, 11, 111, 0)
    ),
    url("../images/bg-hsh-map2.png");
  color: #ccc;
}

.start-btn-docks {
  margin-left: -4px;
  margin-right: -4px;
  background-position: 0px 158px;
}
.start-btn-docks:hover {
  background-position: 0px 158px;
}
.start-btn-docks:hover ~ #titleImg {
  left: -6rem;
  top: -16rem;
  transition: left 2800ms, top 1600ms;
}
.start-btn-graveyard {
  margin-left: -4px;
  margin-right: -4px;
  background-position: 660px 314px;
}
.start-btn-graveyard:hover {
  background-position: 660px 314px;
}
.start-btn-graveyard:hover ~ #titleImg {
  left: 13rem;
  top: -22rem;
  transition: left 2200ms, top 800ms;
}
.start-btn-forest {
  margin-left: -4px;
  margin-right: -4px;
  background-position: 260px 0px;
}
.start-btn-forest:hover {
  background-position: 260px 0px;
}
.start-btn-forest:hover ~ #titleImg {
  left: 36rem;
  top: -27rem;
  transition: left 4800ms, top 3600ms;
}

#lvlUp {
  background: linear-gradient(
      to top,
      rgba(200, 100, 140, 0.2),
      rgba(11, 11, 111, 0)
    ),
    url("../images/skull_n_girls2.png");
  background-size: cover;
  color: #bbb;
  width: 240px;
  height: 120px;
  box-shadow: 0px 5px 20px #8e569f;
}

#lvlUp:enabled:hover {
  box-shadow: 0px 10px 22px #8e569f;
  filter: brightness(2);
}

#attack {
  background-image: linear-gradient(
    to top,
    rgba(200, 100, 140, 0.2),
    rgba(11, 11, 111, 0)
  );
}

#attack:hover {
  background-image: linear-gradient(
    to top,
    rgba(200, 100, 140, 0.5),
    rgba(11, 11, 111, 0)
  );
  color: #ccc;
}

#special-attack {
  background-image: linear-gradient(
    to top,
    rgba(200, 165, 100, 0.2),
    rgba(11, 11, 111, 0)
  );
}

#special-attack:hover {
  background-image: linear-gradient(
    to top,
    rgba(212, 188, 79, 0.5),
    rgba(11, 11, 111, 0)
  );
  color: #ccc;
}

#heal {
  background-image: linear-gradient(
    to top,
    rgba(80, 204, 90, 0.2),
    rgba(11, 11, 111, 0)
  );
}

#heal:hover {
  background-image: linear-gradient(
    to top,
    rgba(80, 204, 90, 0.5),
    rgba(11, 11, 111, 0)
  );
  color: #ccc;
}

#back-to-map {
  color: #999;
}

#back-to-map:hover {
  color: #ccc;
}

@keyframes boom {
  0% {
    opacity: 1;
    filter: blur(8px);
    left: 240px;
  }
  80% {
    opacity: 0.2;
    filter: blur(4px);
    left: 240px;
  }

  100% {
    opacity: 1;
    filter: blur(8px);
    left: 512px;
  }
}

@keyframes aura {
  0% {
    opacity: 0;
    filter: blur(1px);
    transform: scale(1);
  }
  75% {
    opacity: 0.5;
    filter: blur(5px);
    transform: scale(2);
  }
  100% {
    opacity: 0.1;
    filter: blur(12px);
  }
}

@keyframes showDmg {
  0% {
    opacity: 0.8;
    filter: blur(0.1px);
    transform: scale(1);
  }
  100% {
    opacity: 0;
    filter: blur(3px);
    transform: scale(3);
  }
}

.floatingMonk {
  animation-name: floatingAnim;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@keyframes floatingAnim {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(0px);
  }
}

@media screen and (max-width: 800px) {
  #titleImg {
    display: none;
  }
}
</style>
